import Utils from '../utils';
import StorageService from "./StorageService";

class ThemeService {

  static CACHE_KEY = 'subdealer_profile';
  static TTL = 24 * 60 * 60 * 1000; // 24 години

  static getConfiguration() {
    const cached = StorageService.getItem(this.CACHE_KEY);

    if (!cached) {
      return null;
    }

    const { data, cachedAt } = cached;

    if (!cachedAt) {
      return null;
    }

    const isExpired = Date.now() - cachedAt > this.TTL;

    if (isExpired) {
      return null;
    }

    return data;

    // return StorageService.getItem(this.CACHE_KEY);
  }

  static saveConfiguration(data) {
    StorageService.setItem(this.CACHE_KEY, {
      data,
      cachedAt: Date.now(),
    });
  }

  static applyTheme(data) {

    if (!data) {
      return;
    }

    const root = document.documentElement;

    const mainHex = data.color_main ? Utils.rgbaToHex(data.color_main) : '#fc0';
    const secondHex = data.color_second ? Utils.rgbaToHex(data.color_second) : '#ccff99';

    root.style.setProperty('--main-color', mainHex);
    root.style.setProperty('--main-color-rgb', Utils.extractRGB(mainHex));
    root.style.setProperty('--main-color-hover', Utils.shadeColor(mainHex, 10));
    root.style.setProperty('--main-color-active', Utils.shadeColor(mainHex, -10));

    root.style.setProperty('--second-color', secondHex);


    const contrast = Utils.getColorContrast(mainHex);
    root.style.setProperty('--main-contrast-color', contrast === 'dark' ? '#000000' : '#ffffff');


    if (data.company_name) {
      document.title = data.company_name;
    }

    const favicon = document.querySelector("link[rel~='icon']");
    if (favicon) {
      favicon.href = `/favicon.ico`;
    }

  }

  static getLogoUrl() {

    const config = ThemeService.getConfiguration();

    if (config?.logo) {
      return Utils.getFullUrl(config.logo);
    }

    return null;
  }
}

export default ThemeService;